import { Fancybox } from "@fancyapps/ui";

declare global {
    interface Window {
        reCaptchaLoaded: Function;
    }
}

export function initializationForms() {
    console.log("initializationForms");
    const feedbackForm = document.getElementById(
        "footerForm",
    ) as HTMLFormElement | null;
    const callBackForm = document.getElementById(
        "callbackForm_form",
    ) as HTMLFormElement | null;
    const requestForm = document.getElementById(
        "RequestForm_form",
    ) as HTMLFormElement | null;
    if (feedbackForm) new FooterFeedback(feedbackForm);
    if (callBackForm) new CallBackForm(callBackForm);
    if (requestForm) new RequestForm(requestForm);
}

type FeedbackErrors = Record<string, string[]>;

abstract class Feedback {
    protected form: HTMLFormElement;
    protected action: string;
    protected submitBtn: HTMLElement | null;
    protected widgetId: number = 0;
    protected recaptcha_site_key: string;

    protected abstract validate(): boolean;

    protected abstract showErrors(errors: FeedbackErrors): void;

    protected abstract showSuccess(data: any): void;

    protected abstract initFields(): void;

    protected constructor(form: HTMLFormElement) {
        this.form = form;
        this.action = this.form.action;
        this.submitBtn = this.form.querySelector("[type='submit']");
        this.form.addEventListener("submit", async (e) => {
            e.preventDefault();
            await this.submit();
        });

        const meta = document.querySelector<HTMLMetaElement>(
            'meta[name="recaptcha-site-key"]',
        );
        if (!meta || !meta.content) {
            throw new Error("Meta-тег recaptcha-site-key не найден или пуст");
        }
        this.recaptcha_site_key = meta.content;

        this.injectRecaptcha();
    }

    protected randomId() {
        return `fb-form-${Math.random().toString(36).substr(2, 9)}`;
    }

    protected injectRecaptcha() {
        // создаём div, куда grecaptcha.render поместит виджет
        const wrapper =
            this.form.querySelector<HTMLDivElement>("div.recaptcha");
        console.log(wrapper);
        if (wrapper === null) return;

        const container = document.createElement("div");
        container.id = `${this.form.id || this.randomId()}-recaptcha`;
        // можно добавить класс для стилизации
        container.classList.add("g-recaptcha");
        // вставляем перед кнопкой отправки или в конец формы
        wrapper.appendChild(container);

        let that = this;
        let loadPrevCaptcha =
            typeof window.reCaptchaLoaded === "undefined"
                ? function () {}
                : window.reCaptchaLoaded;

        window.reCaptchaLoaded = function () {
            // Call the previous loaded function
            // to support multiple recaptchas on the same page
            loadPrevCaptcha();

            that.widgetId = grecaptcha.render(container.id, {
                sitekey: that.recaptcha_site_key,
                theme: "light",
            });
        };

        let src =
            "//www.google.com/recaptcha/api.js?onload=reCaptchaLoaded&render=explicit&hl=ru";
        if (
            document.querySelector<HTMLScriptElement>(
                'script[src="' + src + '"]',
            ) === null
        ) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.defer = true;
            script.src = src;
            document.getElementsByTagName("body")[0].appendChild(script);
        }
    }

    protected getFormErrorField(): HTMLElement | null {
        const prev = this.submitBtn?.previousElementSibling;
        if (
            prev &&
            prev.tagName === "DIV" &&
            prev.classList.contains("error")
        ) {
            return prev as HTMLElement;
        }
        return null;
    }

    protected getOrCreateErrorField(): HTMLElement {
        let errorElement = this.getFormErrorField();
        if (errorElement) {
            return errorElement;
        } else {
            errorElement = document.createElement("div");
            errorElement.classList.add("error");
            this.submitBtn?.insertAdjacentElement("beforebegin", errorElement);
            return errorElement;
        }
    }

    protected setFormError(text: string): void {
        if (this.submitBtn) {
            let errorElement = this.getOrCreateErrorField();
            console.log(errorElement);
            errorElement.innerHTML = text;
        } else {
            console.error("Нет кнопки, перед которой выводить ошибку");
        }
    }

    protected removeFormError(): void {
        const erElement = this.getFormErrorField();
        if (erElement) {
            erElement.remove();
        }
    }

    private async submit() {
        this.removeFormError();
        if (!this.validate()) return;

        const token = grecaptcha.getResponse(this.widgetId);

        if (!token) {
            this.setFormError("Пожалуйста, подтвердите, что вы не робот");
            return;
        }

        const formData = new FormData(this.form);
        formData.set("g-recaptcha-response", token);

        try {
            const response = await fetch(this.action, {
                method: "POST",
                body: formData,
                headers: { Accept: "application/json" },
            });

            response.ok
                ? this.showSuccess(await response.json())
                : this.showErrors(await response.json());
        } finally {
            // сбрасываем виджет, чтобы можно было отправить ещё раз
            grecaptcha.reset(this.widgetId);
        }
    }
}

class RequestForm extends Feedback {
    phone: HTMLInputElement;
    name: HTMLInputElement;
    product: HTMLInputElement;

    constructor(form: HTMLFormElement) {
        super(form);
        this.phone = form.querySelector("[name='phone']") as HTMLInputElement;
        this.name = form.querySelector("[name='name']") as HTMLInputElement;
        this.product = form.querySelector("[name='phone']") as HTMLInputElement;
        if (!this.name || !this.phone || !this.product) {
            return;
        }
        this.initFields();
    }

    protected initFields(): void {
        this.phone.addEventListener("focus", () => this.clearError(this.phone));
        this.name.addEventListener("focus", () => this.clearError(this.phone));
        this.product.addEventListener("focus", () =>
            this.clearError(this.phone),
        );
    }

    private clearError(field: HTMLInputElement): void {
        if (field.classList.contains("error")) {
            field.classList.remove("error");
        }
        const sibling = field.nextElementSibling;
        if (
            sibling &&
            sibling.tagName === "DIV" &&
            sibling.classList.contains("error")
        ) {
            sibling.remove();
        }
    }

    private setFieldError(field: HTMLElement, message: string): void {
        this.clearError(field as HTMLInputElement);
        field.classList.add("error");
        const errorElement = document.createElement("div");
        errorElement.classList.add("error");
        errorElement.innerText = message;
        field.insertAdjacentElement("afterend", errorElement);
    }

    protected validate(): boolean {
        if (!this.phone.value.trim()) {
            this.setFieldError(this.phone, "Укажите телефон");
            return false;
        }
        if (!this.name.value.trim()) {
            this.setFieldError(this.name, "Укажите имя");
            return false;
        }

        return true;
    }

    protected showErrors(errors: FeedbackErrors): void {
        Object.entries(errors).forEach(([key, messages]) => {
            const field = this[key as keyof CallBackForm] as
                | HTMLInputElement
                | undefined;
            field
                ? this.setFieldError(field, messages.join("<br>"))
                : this.setFormError(messages.join("<br>"));
        });
    }

    protected showSuccess(): void {
        this.form.reset();
        Fancybox.close();
        Fancybox.show([{ src: "#callbackSuccess", type: "inline" }]);
    }
}
class CallBackForm extends Feedback {
    phone: HTMLInputElement;

    constructor(form: HTMLFormElement) {
        super(form);
        this.phone = form.querySelector("[name='phone']") as HTMLInputElement;
        if (!this.phone) {
            return;
        }
        this.initFields();
    }

    protected initFields(): void {
        this.phone.addEventListener("focus", () => this.clearError(this.phone));
    }

    private clearError(field: HTMLInputElement): void {
        if (field.classList.contains("error")) {
            field.classList.remove("error");
        }
        const sibling = field.nextElementSibling;
        if (
            sibling &&
            sibling.tagName === "DIV" &&
            sibling.classList.contains("error")
        ) {
            sibling.remove();
        }
    }

    private setFieldError(field: HTMLElement, message: string): void {
        this.clearError(field as HTMLInputElement);
        field.classList.add("error");
        const errorElement = document.createElement("div");
        errorElement.classList.add("error");
        errorElement.innerText = message;
        field.insertAdjacentElement("afterend", errorElement);
    }

    protected validate(): boolean {
        if (!this.phone.value.trim()) {
            this.setFieldError(this.phone, "Укажите телефон");
            return false;
        }
        return true;
    }

    protected showErrors(errors: FeedbackErrors): void {
        Object.entries(errors).forEach(([key, messages]) => {
            const field = this[key as keyof CallBackForm] as
                | HTMLInputElement
                | undefined;
            field
                ? this.setFieldError(field, messages.join("<br>"))
                : this.setFormError(messages.join("<br>"));
        });
    }

    protected showSuccess(): void {
        this.form.reset();
        Fancybox.close();
        Fancybox.show([{ src: "#callbackSuccess", type: "inline" }]);
    }
}

class FooterFeedback extends Feedback {
    name: HTMLInputElement;
    phone: HTMLInputElement;
    message: HTMLInputElement;
    agreement: HTMLInputElement;

    constructor(form: HTMLFormElement) {
        super(form);
        this.name = form.querySelector("[name='name']") as HTMLInputElement;
        this.phone = form.querySelector("[name='phone']") as HTMLInputElement;
        this.message = form.querySelector(
            "[name='message']",
        ) as HTMLInputElement;
        this.agreement = form.querySelector(
            "[name='agreement']",
        ) as HTMLInputElement;
        if (!this.name || !this.phone || !this.message || !this.agreement) {
            return;
        }
        this.initFields();
    }

    protected initFields(): void {
        [this.name, this.phone, this.message].forEach((field) =>
            field.addEventListener("focus", () => this.clearError(field)),
        );
    }

    private clearError(field: HTMLInputElement): void {
        if (field.classList.contains("error")) {
            field.classList.remove("error");
        }
        const sibling = field.nextElementSibling;
        if (
            sibling &&
            sibling.tagName === "DIV" &&
            sibling.classList.contains("error")
        ) {
            sibling.remove();
        }
    }

    private setFieldError(field: HTMLElement, message: string): void {
        this.clearError(field as HTMLInputElement);
        field.classList.add("error");
        const errorElement = document.createElement("div");
        errorElement.classList.add("error");
        errorElement.innerText = message;
        field.insertAdjacentElement("afterend", errorElement);
    }

    protected validate(): boolean {
        let isValid = true;
        if (!this.name.value.trim()) {
            this.setFieldError(this.name, "Укажите имя");
            isValid = false;
        }
        if (!this.phone.value.trim()) {
            this.setFieldError(this.phone, "Укажите телефон");
            isValid = false;
        }
        if (!this.agreement.checked) {
            this.setFormError(
                "Требуется согласие с условиями политики конфиденциальности.",
            );
            isValid = false;
        }
        return isValid;
    }

    protected showErrors(errors: FeedbackErrors): void {
        Object.entries(errors).forEach(([key, messages]) => {
            const field = this[key as keyof FooterFeedback] as
                | HTMLInputElement
                | undefined;
            field
                ? this.setFieldError(field, messages.join("<br>"))
                : this.setFormError(messages.join("<br>"));
        });
    }

    protected showSuccess(): void {
        this.form.reset();
        Fancybox.close();
        Fancybox.show([{ src: "#callbackSuccess", type: "inline" }]);
    }
}
